export default "__VITE_ASSET__CsoEi9GK__"